import React, { ReactElement } from 'react';
import WidgetActionsMenu from 'adapter/in/dashboards/pages/Widget/ActionsMenu';
import { useOnDeleteDashboardAnalysisModal } from 'adapter/in/dashboards/containers/Modals/DeleteDashboardAnalysisModal/useDeleteDashboardAnalysisModal';
import { useNavigation } from 'adapter/in/common/hooks/useNavigation';
import { analysisRootPath, dashboardsPath } from 'adapter/in/common/routes';

type WidgetActionsMenuProps = {
    dashboardId: string;
    analysisId: string;
    showMenu: boolean;
};

export const AnalysisActionsMenuContainer = (props: WidgetActionsMenuProps): ReactElement => {
    const { dashboardId, analysisId, showMenu } = props;

    const { handleOnDelete, onDeleteModal } = useOnDeleteDashboardAnalysisModal(dashboardId, analysisId);
    const { navigationPushToContext } = useNavigation();

    return (
        <>
            <WidgetActionsMenu
                show={showMenu}
                showOptions={false}
                onDelete={() => {
                    handleOnDelete();
                }}
                onEdit={() => {
                    navigationPushToContext(`${analysisRootPath}/analysis/${analysisId}`, dashboardsPath);
                }}
                isEditDisabled={() => false}
            />
            {onDeleteModal}
        </>
    );
};

export default AnalysisActionsMenuContainer;
